module.exports = __webpack_public_path__ + "static/img/信息框@2x.0c48d30c.png";